import React, { useState, useEffect } from 'react';
import ButtonComp from '../../../atoms/Buttons/Presentation/ButtonComp';
import { isMobileDevice, getFullImagePath } from 'common/utilities/utils';
import { useSelector } from 'react-redux';
import ImageComponent from '../../../atoms/Image';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { PopUpView } from '../../MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';

/**
 *
 * @param {*} props - Object
 */
export const CartStatesModuleForm = props => {
  const { modalContent, onCartStatesMethodSubmit, setRef = null, unavailableItems, priceChangedItems } = props;
  const {
    unavailableText = {},
    priceChangeText = {},
    bothChangeText = {},
    infoObject = null,
    discardbuttonTypes,
    confirmButtonTypes,
  } = modalContent;
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const tenantData = useSelector(data => data.tenantReducer);
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const processItems = (fooditem, ind, type) => {
    const { newFoodLineItem, cartPrice, menuPrice } = fooditem;
    const { item } = newFoodLineItem;
    const { dname, imageName } = item;

    const dataTestId = type === 'unavailables' ? 'unavailable-items' : 'priceChanged-items';

    return (
      <div className='cart-card-row' key={ind} data-testid={dataTestId}>
        <div className='cart-card d-flex'>
          <ImageComponent
            className='cart-card-image'
            defaultPath={getFullImagePath(null, tenantData, true)}
            srcFile={getFullImagePath(imageName, tenantData)}
          />
          <div className='cart-card-name' id={ind} tabIndex='0'>
            <div className='cart-item-dname'>{dname[0].value}</div>
            <div className='cart-item-price'>
              {tenantData.currencySymbol}
              {type === 'unavailables' ? cartPrice : menuPrice}
            </div>
            {type === 'priceChanges' && (
              <span className='old-price'>
                {tenantData.currencySymbol}
                {cartPrice}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const desktopButtonTypes = (
    <React.Fragment>
      <ButtonComp
        data-testid='cartstate-button-comp'
        key={discardbuttonTypes.type}
        className={`${discardbuttonTypes.selectDefault && 'default-selected'}`}
        onClickHandler={event => {
          onCartStatesMethodSubmit(event, discardbuttonTypes.type);
        }}
        id='CartStateModuleFormSubmit'
        type='submit'
        className='button whiteButton order-type-button'
        aria-label={`order type ${discardbuttonTypes.buttonText}`}
      >
        {translateWithI18Next(discardbuttonTypes.buttonText)}
      </ButtonComp>
      <ButtonComp
        data-testid='cartstate-button-comp'
        key={confirmButtonTypes.type}
        className={`${confirmButtonTypes.selectDefault && 'default-selected'}`}
        onClickHandler={event => {
          onCartStatesMethodSubmit(event, confirmButtonTypes.type);
        }}
        id='CartStateModuleFormSubmit'
        type='submit'
        className='button whiteButton order-type-button CartStateModuleFormSubmitconfirm'
        aria-label={`order type ${translateWithI18Next(confirmButtonTypes.buttonText)}`}
      >
        {translateWithI18Next(confirmButtonTypes.buttonText)}
      </ButtonComp>
    </React.Fragment>
  );
  const mobileButtonTypes = (
    <React.Fragment>
      <ButtonComp
        data-testid='cartstate-button-comp'
        key={confirmButtonTypes.type}
        className={`${confirmButtonTypes.selectDefault && 'default-selected'}`}
        onClickHandler={event => {
          onCartStatesMethodSubmit(event, confirmButtonTypes.type);
        }}
        id='CartStateModuleFormSubmit'
        type='submit'
        className='button whiteButton order-type-button CartStateModuleFormSubmitconfirm'
        aria-label={`order type ${translateWithI18Next(confirmButtonTypes.buttonText)}`}
      >
        {translateWithI18Next(confirmButtonTypes.buttonText)}
      </ButtonComp>
      <ButtonComp
        data-testid='cartstate-button-comp'
        key={discardbuttonTypes.type}
        className={`${discardbuttonTypes.selectDefault && 'default-selected'}`}
        onClickHandler={event => {
          onCartStatesMethodSubmit(event, discardbuttonTypes.type);
        }}
        id='CartStateModuleFormSubmit'
        type='submit'
        className='button whiteButton order-type-button'
        aria-label={`order type ${translateWithI18Next(discardbuttonTypes.buttonText)}`}
      >
        {translateWithI18Next(discardbuttonTypes.buttonText)}
      </ButtonComp>
    </React.Fragment>
  );
  const unavailableItemCart = () => {
    return (
      <React.Fragment>
        {unavailableItems.map((fooditem, ind) => {
          let type = 'unavailables';
          return processItems(fooditem, ind, type);
        })}
      </React.Fragment>
    );
  };
  const priceChangedItemCart = () => {
    return (
      <React.Fragment>
        {priceChangedItems.map((fooditem, ind) => {
          let type = 'priceChanges';
          return processItems(fooditem, ind, type);
        })}
      </React.Fragment>
    );
  };
  useEffect(() => {
    if (unavailableItems.length && !priceChangedItems.length) {
      PopUpView({
        popupTitle: [
          translateWithI18Next(unavailableText.contentText),
          translateWithI18Next(unavailableText.contentMain),
          translateWithI18Next(unavailableText.cartQuery),
        ].join(' '),
      });
    } else if (!unavailableItems.length && priceChangedItems.length) {
      PopUpView({
        popupTitle: [
          translateWithI18Next(priceChangeText.contentText),
          translateWithI18Next(priceChangeText.contentMain),
          translateWithI18Next(priceChangeText.cartQuery),
        ].join(' '),
      });
    } else if (unavailableItems.length && priceChangedItems.length) {
      PopUpView({
        popupTitle: [
          translateWithI18Next(bothChangeText.contentText),
          translateWithI18Next(bothChangeText.contentMain),
          translateWithI18Next(bothChangeText.cartQuery),
        ].join(' '),
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unavailableItems, priceChangedItems]);
  return (
    <React.Fragment>
      <div ref={setRef} className='cart-module-form' data-testid='cart-modal-component'>
        {unavailableItems.length && !priceChangedItems.length ? (
          <div className='content-text' data-testid='contenttext-component'>
            {translateWithI18Next(unavailableText.contentText)}{' '}
            <span className='red-text'>{translateWithI18Next(unavailableText.contentMain)}</span>{' '}
            {translateWithI18Next(unavailableText.cartQuery)}
          </div>
        ) : null}
        {!unavailableItems.length && priceChangedItems.length ? (
          <div className='content-text' data-testid='contenttext-component'>
            {translateWithI18Next(priceChangeText.contentText)}{' '}
            <span className='red-text'>{translateWithI18Next(priceChangeText.contentMain)}</span>{' '}
            {translateWithI18Next(priceChangeText.cartQuery)}
          </div>
        ) : null}
        {unavailableItems.length && priceChangedItems.length ? (
          <div className='content-text' data-testid='contenttext-component'>
            {translateWithI18Next(bothChangeText.contentText)}{' '}
            <span className='red-text'>{translateWithI18Next(bothChangeText.contentMain)}</span>{' '}
            {translateWithI18Next(bothChangeText.cartQuery)}
          </div>
        ) : null}
        {priceChangedItems.length && infoObject ? (
          <div role='alert' className='info-text' data-testid='info-component'>
            <span>{translateWithI18Next(infoObject.infoText)}</span>
          </div>
        ) : null}
        {unavailableItems && unavailableItems.length ? unavailableItemCart() : null}
        {priceChangedItems && priceChangedItems.length ? priceChangedItemCart() : null}
        <form className='form' onSubmit={onCartStatesMethodSubmit} data-testid='form-component'>
          <section className='form__section'>
            <div className='order-button-section'>{isMobile ? mobileButtonTypes : desktopButtonTypes}</div>
            <div className='clearfix'></div>
          </section>
        </form>
      </div>
    </React.Fragment>
  );
};

export default CartStatesModuleForm;
